export enum ClassificacaoDocumento {
  EMENDA = 'emenda',
  EMENDA_ARTIGO_ONDE_COUBER = 'emendaArtigoOndeCouber',
  NORMA = 'norma',
  PROJETO = 'projeto',
}
